module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_round_darkbrown.d03126b4.png";